import * as THREE from 'three'
// import {radians} from './helpers'

const scene = new THREE.Scene()
scene.fog = new THREE.Fog(0x286fbb, 10, 1000)

// add subtle ambient lighting
var ambientLight = new THREE.AmbientLight(0x555555)
scene.add(ambientLight)

// Spotlight
var spotLight = new THREE.DirectionalLight(0xdddddd, .5, 100)
//var spotLight = new THREE.SpotLight(0xffffff)
//spotLight.position.set(-70, 90, 35)
spotLight.position.set(0, 35, 0)

/*
 * Shadows:
 * https://threejs.org/examples/?q=shado#webgl_shadow_contact
 */
spotLight.castShadow = true
spotLight.shadow.mapSize.width = 512 // default
spotLight.shadow.mapSize.width = 512 // default
spotLight.shadow.mapSize.height = 512 // default
scene.add(spotLight)

// Directional Light
var light2 = new THREE.DirectionalLight(0xdddddd, .5, 100)
light2.position.set(-70, 90, 35)
scene.add(light2)

// Axes
// const axes = new THREE.AxesHelper(20)
// scene.add(axes)

// Floor
// let floorGeometry = new THREE.PlaneGeometry(500, 500)
// floorGeometry.rotateX(radians(90))
// floorGeometry.rotateZ(radians(180))
// floorGeometry.translate(0, -1, 0)
// let floorMaterial = new THREE.MeshLambertMaterial({
//   color: 0x286fbb
// })
// let floor = new THREE.Mesh(floorGeometry, floorMaterial)
// floor.receiveShadow = true
// scene.add(floor)

export default scene